package com.milta.core.appconfig

import kotlinx.serialization.Serializable

/** GET /api/v1/app-config — feature-flag style config shared by mobile and the web dashboard. */
@Serializable
data class AppConfigResponse(val routarEnabled: Boolean)
